export const BACKFILL_JOB_MAIL_MODAL_KEY = 'backfill-jobmail-modal'
export const NEWSLETTER_SUBSCRIPTION_KEY = (newsletterId) => `newsletter-subscription-${newsletterId}`
